<template>
    <button
        type="button"
        aria-label="открыть видео"
        class="group relative aspect-video w-full shrink-0 rounded-20"
        @click="handleOpenVideo">
        <picture class="w-full object-cover">
            <source
                v-if="preview?.url"
                type="image/webp"
                :srcset="
                    getMediaLink(preview.url) ||
                    '/assets/images/ui/placeholder/webp/cromi.webp'
                " />
            <img
                width="420"
                height="240"
                :alt="title || 'video preview'"
                :src="
                    getMediaLink(preview?.webp_url || preview?.url || '') ||
                    '/assets/images/ui/placeholder/jpg-png/cromi.png'
                "
                class="h-full w-full rounded-8 xl:rounded-12" />
        </picture>
        <span
            v-if="title"
            v-html="title"
            :class="
                size === 'medium'
                    ? 'rounded-bl-8 rounded-tr-8 p-3 text-16/148 sm:px-5 sm:py-4 sm:text-24/133'
                    : 'rounded-bl-8 rounded-tr-8 p-3 text-16/148 sm:px-5 sm:py-4 sm:text-24/133 md:rounded-bl-12 md:rounded-tr-12 lg:px-6 lg:py-4 lg:text-32/100 xl:px-8 xl:py-6 xl:text-48/100'
            "
            class="absolute bottom-0 left-0 bg-video-title font-semibold text-ash-200" />
        <span
            v-if="duration"
            v-html="duration"
            class="absolute bottom-2 right-2 rounded-8 bg-black/50 p-2.5 text-16/120 text-ash-200" />
        <PlaySvg
            class="absolute inset-1/2 size-[5.375rem] -translate-x-1/2 -translate-y-1/2 text-black group-hover:text-accent" />
    </button>
</template>

<script setup lang="ts">
import type { Image } from '~/types/global.types'

import PlaySvg from '~/components/base/base-video/PlaySvg.vue'

const props = defineProps({
    size: {
        type: String as PropType<'medium' | 'big'>,
        default: 'medium',
    },
    preview: {
        type: [Object, null] as PropType<Image | null>,
        default: null,
    },
    duration: {
        type: String as PropType<string>,
        default: null,
    },
    title: {
        type: [String, null] as PropType<string | null>,
        default: null,
    },
    url: {
        type: String as PropType<string>,
        default: null,
    },
})

const modalStore = useModalStore()

function handleOpenVideo() {
    modalStore.setVideoLink(props.url)
    modalStore.open('video')
}
</script>
